// Raw Stock History Action Types
export const FETCH_RAW_STOCK_HISTORY_REQUEST = 'FETCH_RAW_STOCK_HISTORY_REQUEST';
export const FETCH_RAW_STOCK_HISTORY_SUCCESS = 'FETCH_RAW_STOCK_HISTORY_SUCCESS';
export const FETCH_RAW_STOCK_HISTORY_FAILURE = 'FETCH_RAW_STOCK_HISTORY_FAILURE';

export const FETCH_RAW_STOCK_HISTORY_BY_STOCK_CODE_REQUEST = 'FETCH_RAW_STOCK_HISTORY_BY_STOCK_CODE_REQUEST';
export const FETCH_RAW_STOCK_HISTORY_BY_STOCK_CODE_SUCCESS = 'FETCH_RAW_STOCK_HISTORY_BY_STOCK_CODE_SUCCESS';
export const FETCH_RAW_STOCK_HISTORY_BY_STOCK_CODE_FAILURE = 'FETCH_RAW_STOCK_HISTORY_BY_STOCK_CODE_FAILURE';

export const FETCH_RAW_STOCK_HISTORY_BY_DATE_RANGE_REQUEST = 'FETCH_RAW_STOCK_HISTORY_BY_DATE_RANGE_REQUEST';
export const FETCH_RAW_STOCK_HISTORY_BY_DATE_RANGE_SUCCESS = 'FETCH_RAW_STOCK_HISTORY_BY_DATE_RANGE_SUCCESS';
export const FETCH_RAW_STOCK_HISTORY_BY_DATE_RANGE_FAILURE = 'FETCH_RAW_STOCK_HISTORY_BY_DATE_RANGE_FAILURE';

export const FETCH_RAW_STOCK_HISTORY_BY_CREATED_BY_REQUEST = 'FETCH_RAW_STOCK_HISTORY_BY_CREATED_BY_REQUEST';
export const FETCH_RAW_STOCK_HISTORY_BY_CREATED_BY_SUCCESS = 'FETCH_RAW_STOCK_HISTORY_BY_CREATED_BY_SUCCESS';
export const FETCH_RAW_STOCK_HISTORY_BY_CREATED_BY_FAILURE = 'FETCH_RAW_STOCK_HISTORY_BY_CREATED_BY_FAILURE';

export const CREATE_RAW_STOCK_HISTORY_REQUEST = 'CREATE_RAW_STOCK_HISTORY_REQUEST';
export const CREATE_RAW_STOCK_HISTORY_SUCCESS = 'CREATE_RAW_STOCK_HISTORY_SUCCESS';
export const CREATE_RAW_STOCK_HISTORY_FAILURE = 'CREATE_RAW_STOCK_HISTORY_FAILURE';

export const GET_RAW_STOCK_HISTORY_REPORT_REQUEST = 'GET_RAW_STOCK_HISTORY_REPORT_REQUEST';
export const GET_RAW_STOCK_HISTORY_REPORT_SUCCESS = 'GET_RAW_STOCK_HISTORY_REPORT_SUCCESS';
export const GET_RAW_STOCK_HISTORY_REPORT_FAILURE = 'GET_RAW_STOCK_HISTORY_REPORT_FAILURE'; 